export default "__VITE_ASSET__B_RYZJqv__"